import React, { useEffect } from 'react';
import { ChakraProvider, theme } from '@chakra-ui/react';
import { Provider } from 'react-redux';
import store from './store';
import BasePage from './components/base-page';
import './App.scss';

function App() {
  useEffect(() => {
    const rootElement = document.getElementById('root');
    if (!rootElement) return;

    const sendHeight = () => {
      const height = Math.max(
        document.documentElement.scrollHeight,
        document.body.scrollHeight,
        rootElement.scrollHeight
      );
      window.parent.postMessage({ type: 'IFRAME_RESIZE', height }, '*');
    };

    const resizeObserver = new ResizeObserver(() => {
      sendHeight();
    });

    resizeObserver.observe(rootElement);
    resizeObserver.observe(document.body);

    // Also send height initially and on window resize
    sendHeight();
    window.addEventListener('resize', sendHeight);

    return () => {
      resizeObserver.disconnect();
      window.removeEventListener('resize', sendHeight);
    };
  }, []);

  return (
    <Provider store={store}>
      <ChakraProvider theme={theme}>
        <BasePage />
      </ChakraProvider>
    </Provider>
  );
}

export default App;
